<template>
  <div class="home">

    <div class="banner">
      <img src="../../assets/banner.jpg" alt="新社汇" />
      <div class="b-info text-white animated slideDown">
        <div class="title">
          <h1>薪社汇</h1>
          <h1>打通人力资源服务最后一公里</h1>
        </div>
        <p>300+全国直营网点、1,000,000+年社保代缴人次</p>
        <p>100%HRO系统线上智能处理订单、平均5年+工作经验的专业客服团队</p>
      </div>
    </div>

    <div class="network" :class="{'anitr': this.activeClass('network') }" v-scrollWatch="{...watchOptions, name: 'network'}">
      <div class="title">
        <Title title="互联网+人力薪酬" bgText="PRODUCT" remark=" " />
      </div>
      <div class="select">
        <div class="options" :class="{'active': selectOption == 1}" @click="changeOption(1)">社保代理</div>
        <div class="options" :class="{'active': selectOption == 2}" @click="changeOption(2)">薪资代发</div>
        <div class="options" :class="{'active': selectOption == 3}" @click="changeOption(3)">用工管理</div>
        <div class="options" :class="{'active': selectOption == 4}" @click="changeOption(4)">人事服务</div>
        <div class="options" :class="{'active': selectOption == 5}" @click="changeOption(5)">综合福利</div>
      </div>
      <div class="s-list" v-show="selectOption == 1">
        <div class="s-item">
          <div class="avader">
            <img src="../../assets/network-1.png" alt="新社汇" />
          </div>
          <div class="text">
            <p class="title">300+全国直营网点</p>
            <h1>属地化代缴代办</h1>
            <p>社保公积金申报、缴纳、调基。</p>
            <p>员工异地就医备案及相关证明。</p>
            <p>全国各地属地政策咨询、解答。</p>
            <p>资料系统提交、服务准确率高。</p>
          </div>
        </div>
      </div>
      <div class="s-list" v-show="selectOption == 2">
        <div class="s-item">
          <div class="avader">
            <img src="../../assets/network-2.png" alt="新社汇" />
          </div>
          <div class="text">
            <p class="title">支持多种计薪方式、适配薪酬模型</p>
            <h1>处理资金有保障、更安全</h1>
            <p>企业薪资计算、代发。</p>
            <p>员工属地化个税申报、代缴。</p>
            <!-- <p>员工薪资查询、授信、预支。</p> -->
            <p>电子工资单查询明细一目了。</p>
          </div>
        </div>
      </div>
      <div class="s-list" v-show="selectOption == 3">
        <div class="s-item">
          <div class="avader">
            <img src="../../assets/network-3.png" alt="新社汇" />
          </div>
          <div class="text">
            <p class="title">调整劳动关系、优化用工方式</p>
            <h1>增强组织灵活性、降低风险</h1>
            <p>岗位外包：员工招聘、入离职等一系列人员及岗位管理工作。</p>
            <p>业务流程外包:部分或全部的非核心流程外包，避免核心资源浪费。</p>
            <p>项目外包：非核心工作、临时性项目及短期需求外包专业团队处理执行。</p>
            <p>人才租赁：按一定期限或按项目制租借人才，弹性管理更灵活。</p>
          </div>
        </div>
      </div>
      <div class="s-list" v-show="selectOption == 4">
        <div class="s-item">
          <div class="avader">
            <img src="../../assets/network-4.png" alt="新社汇" />
          </div>
          <div class="text">
            <p class="title">人事代理、派遣服务</p>
            <h1>放心托管繁琐事务</h1>
            <p>高端猎头、员工招聘、背景调查。</p>
            <p>员工入离职手续办理、合同签订。</p>
            <p>居住证等其他证件、人事证明办理。</p>
          </div>
        </div>
      </div>
      <div class="s-list" v-show="selectOption == 5">
        <div class="s-item">
          <div class="avader">
            <img src="../../assets/network-5.png" alt="新社汇" />
          </div>
          <div class="text">
            <p class="title">提供多种员工福利方案</p>
            <h1>提升员工满意度、降低员工流失率</h1>
            <p>雇主责任险：让雇主有保障、减轻经济责任。</p>
            <p>补充医疗保险：提供个人医药费用补助、减轻医疗负担。</p>
            <p>高端医疗保险：针对高端人群、超高保额、覆盖面广、就医直付。</p>
          </div>
        </div>
      </div>
    </div>

    <div class="plantform" :class="{'anitr': this.activeClass('plantform') }" v-scrollWatch="{...watchOptions, name: 'plantform'}">
      <div class="title">
        <Title title="服务优势" bgText="ADVANTAGE" remark=" " />
      </div>
      <div class="p-list">
        <div class="p-item animated anitr-1" :class="{'slideInUp': activeClass('plantform')}">
          <div class="p-head">
            <h3>TRADITIONAL MANAGEMENT</h3>
            <h1>传统管理</h1>
            <img src="../../assets/plantform-1.png" alt="新社汇" />
          </div>
          <div class="p-content">
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" alt="新社汇" />
                <span>企业人力成本居高不下</span>
              </div>
            </div>
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" alt="新社汇" />
                <span>分公司缴纳社保难度大</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" alt="新社汇" />
                <span>不熟悉地方政策，易踩雷</span>
              </div>
            </div>
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" alt="新社汇" />
                <span>事务型工作繁杂，总出错</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" alt="新社汇" />
                <span>服务机构不靠谱，资金无保障</span>
              </div>
            </div>
            <!-- <div class="p-tm p-tm-no">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" />
                <span>信息流转脱节、数据不同步</span>
              </div>
            </div>
            <div class="p-tm p-tm-no">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" />
                <span>信息层层流转、数据有风险</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-3.png" />
                <span>服务机构不靠谱、资金无保障</span>
              </div>
            </div> -->
          </div>
        </div>
        <div class="p-vs animated anitr-2" :class="{'slideInUp': activeClass('plantform')}">
          <div class="p-c">
            <p class="vs">vs</p>
            <div class="dot">
              <img src="../../assets/rightA.png" alt="新社汇">
            </div>
          </div>
        </div>
        <div class="p-item animated anitr-3" :class="{'slideInUp': activeClass('plantform')}">
          <div class="p-head p-head-r">
            <h3>XIN SHEHUI</h3>
            <h1>薪社汇</h1>
            <img src="../../assets/plantform-2.png" alt="新社汇" />
          </div>
          <div class="p-content">
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" alt="新社汇" />
                <span>合理优化组织结构降低成本</span>
              </div>
            </div>
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" alt="新社汇" />
                <span>全国300+网点提供全直营服务</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" alt="新社汇" />
                <span>政企合作、合规合法风险可控</span>
              </div>
            </div>
            <div class="p-tm ">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" alt="新社汇" />
                <span>专业团队及时处理，可放心托管</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" alt="新社汇" />
                <span>资金受第三方监管，安全更放心</span>
              </div>
            </div>
            <!-- <div class="p-tm p-tm-no">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" />
                <span>流程可视化、实时监控状态</span>
              </div>
            </div>
            <div class="p-tm p-tm-no">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" />
                <span>数据云端存储、多重权限管控</span>
              </div>
            </div>
            <div class="p-tm">
              <div class="p-tm-b">
                <img src="../../assets/plantform-4.png" />
                <span>资金受第三方监管、安全更放心</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="advantage" :class="{'anitr': this.activeClass('advantage') }" v-scrollWatch="{...watchOptions, name: 'advantage'}">
      <div class="title">
        <Title title="服务价值" bgText="VALUE" remark=" " />
      </div>
      <div class="a-content">
        <div class="a-left">
          <div class="a-item animated anitr-1" :class="{'slideInUp': activeClass('advantage')}">
            <h1>直营服务</h1>
            <p>百城布点的直营网络，为客户提供工资、个税和社保三合一操作。</p>
            <img src="../../assets/advantage-1.png" alt="新社汇" />
          </div>
          <div class="a-item animated anitr-3" :class="{'slideInUp': activeClass('advantage')}">
            <h1>降本增效</h1>
              <p>减少不必要的成本投入，提升工作效率，创造工作价值。</p>
            <img src="../../assets/advantage-2.png" alt="新社汇" />
          </div>

        </div>
        <div class="a-right">
          <div class="a-item animated anitr-2" :class="{'slideInUp': activeClass('advantage')}">
            <h1>合规合法</h1>
            <p>从商业模式和合规运营角度出发，提供传统+灵活用工多方案按需部署。</p>
            <img src="../../assets/advantage-3.png" alt="新社汇" />
          </div>
          <div class="a-item animated anitr-4" :class="{'slideInUp': activeClass('advantage')}">
            <h1>风险把控</h1>
            <p>降低由于政策信息不理解或操作失误等导致的各类问题和风险。</p>
            <img src="../../assets/advantage-4.png" alt="新社汇" />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="concat">
      <div class="title">
        <Title title="会有专业社保咨询顾问与您取得联系" bgText="CONTACT" textType="1" remark=" " />
      </div>
      <div class="input">
        <input type="text" placeholder="姓名" />
        <input type="text" placeholder="电话" />
        <input type="text" placeholder="企业名称" />
      </div>
      <div class="textarea">
        <textarea name="" cols="30" rows="10" placeholder="留言"></textarea>
      </div>
      <div class="btn">
        <button>提交</button>
      </div>
    </div> -->

  </div>
</template>

<script>
import _ from 'lodash';
import Title from '../../components/Title';
import store from '../../store/index'
import { getProducts } from '../../utils/apis';
import scrollWatch from "vue-scrollwatch";

export default {
  name: 'home',
  components: { Title },
  data: function(){
    return{
      menuType: 1,
      products: [],
      selectOption: 1,
      activeMenus: [],
      watchOptions: {
        name:'numbers',
        offset: 500,
        callback: this.spyDomChange.bind(this)
      }
    }
  },
  computed: {

  },
  mounted() {
    this.getProducts();
  },
  methods: {
    activeClass(name){
      return this.activeMenus.indexOf(name) >= 0;
    },
    spyDomChange(node) {
      let menus = this.activeMenus;
      if(menus.indexOf(node.name) < 0){
        menus.push(node.name);
        this.activeMenus = menus;
      }
    },
    getProducts(){
      getProducts().then((res) =>{
        if(res.data.code == 200){
          this.products = res.data.list;
        }
      })
    },
    changeOption(selectOption){
      this.selectOption = selectOption;
    }

  }
}
</script>
<style lang="scss" scoped>
    .home{
      .banner{
        width: 100%;
        position: relative;
          width: 100%;
          overflow: hidden;
          position: relative;
        img{
          width: 100%;
          display: block;
        }
        .b-info{
          position: absolute;
          width: 1200px;
          text-align: left;
          top: 50%;
          left: 50%;
          margin-top:-122px;
          transform: translateX(-50%);
          .title{
            margin-bottom: 80px;
            h1{
              font-size: 50px;
              font-weight: 400;
            }
            &::after{
              content: ' ';
              position: absolute;
              width:45px;
              height:6px;
              background:linear-gradient(90deg,rgba(86,103,234,1),rgba(156,168,255,1));
              bottom:66px;
            }
          }
          p{
            color: #fff;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
          }
        }
      }
      .network{
        transform: translateY(100px);
        .title{
          padding-top: 50px;
        }
        .select{
          width: 710px;
          margin: 0 auto;
          display: flex;
          text-align: center;
          border-bottom: 2px solid #F4F5F8;
          justify-content: space-between;
          .options{
            padding: 18px 0;
            font-size: 18px;
            font-weight: 400;
            color: #666;
            display: inline-block;
            cursor: pointer;
            height: 100%;
            &.active{
              position: relative;
              &::after{
                content: ' ';
                position: absolute;
                width: 100%;
                height: 2px;
                left: 0;
                right: 0;
                bottom: -2px;
                background: #5667EA;
              }
              color: #5667EA;
            }

          }
        }
        .s-list{
          margin-top: 30px;
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          .s-item{
            display: flex;
            .avader{
              width: 494px;
              padding:50px 30px 30px 30px;
              img{
                width: 100%;
              }
            }
            .text{
              width: 460px;
              padding: 86px 5px ;
              .title{
                font-size: 22px;
                padding: 0;
                color: #333;
                line-height: 34px;
              }
              h1{
                font-size: 22px;
                // font-weight: bold;
                color: #333;
                line-height: 34px;
                margin-bottom: 56px;
                position: relative;
                &::after{
                  content: ' ';
                  position: absolute;
                  left: 0;
                  bottom: -28px;
                  width:20px;
                  height:4px;
                  background:linear-gradient(90deg,rgba(86,103,234,1),rgba(156,168,255,1));
                }
              }
              p{
                font-size: 14px;
                color: #999;
                // font-weight: bold;
                line-height: 22px;
              }
            }
          }
        }

      }
      .plantform{
        transform: translateY(100px);
        .title{
          padding-top: 60px;
        }
        .p-list{
          background: url(../../assets/plantform-bg.png) no-repeat;
          width: 100%;
          background-size: cover;
          background-position: 50% 50%;
          background-origin: 0 0;
          display: flex;
          justify-content: center;
          margin: 20px auto;
          .p-item{
            width:340px;
            // height:593px;
            background:#fff;
            box-shadow:0px 8px 27px 4px rgba(43,119,241,0.1);
            border-radius:5px;
            .p-head{
              background: #FFB758;
              padding: 28px;
              position: relative;
              border-radius:5px 5px 0 0;
              h3{
                font-size: 15px;
                font-weight: 400;
                color:rgba(255,255,255,.9);
              }
              h1{
                font-size: 18px;
                color: #fff;
              }
              img{
                width: 70px;
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }
            .p-head-r{
              background:rgba(94,110,236,1);
              opacity:0.9;
            }
            .p-content{
              .p-tm{
                padding: 24px 42px;
                border-bottom: 1px solid #f0f0f0;
                &:last-child{
                  border-bottom: none;
                }
                img{
                  width: 28px;
                  vertical-align: middle;
                }
                span{
                  font-size: 14px;
                  font-weight: 400;
                  color: #666;
                  vertical-align: middle;
                  margin-left: 10px;
                }
                .p-tm-t{
                  padding-left: 28px;
                }
              }
              .p-tm-no{
                padding: 24px 42px 0 42px;
                border-bottom: none;
                .p-tm-b{
                  padding-bottom: 24px;
                  border-bottom: 1px solid #f0f0f0;
                }
              }
            }
          }
          .p-vs{
            padding: 0 82px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            .p-c{
              .vs{
                font-size:50px;
                font-weight:bold;
                color:rgba(112,128,255,1);
                line-height:23px;
                text-shadow:-1px 9px 7px rgba(86,103,234,0.14);
              }
              .dot{
                width: 93px;
                height:11px;
                margin-top: 20px;
                img{
                  height: 100%;
                  width: 100%;
                }
              }
            }
          }
        }
      }
      .advantage{
        padding-bottom: 50px;
        transform: translateY(100px);
        .title{
          padding-top: 70px;
        }
        .a-content{
          background: url(../../assets/advantage-bg.png) no-repeat;
          background-size: 400px 400px;
          background-position: 50% 50%;
          width: 910px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          >div{
            width: 406px;
            .a-item{
              padding: 48px 44px;
              background:#fff;
              box-shadow:0px 8px 27px 4px rgba(43,119,241,0.1);
              border-radius:5px;
              margin-bottom: 40px;
              margin-top: 40px;
              position: relative;
              h1{
                font-size:18px;
                font-weight:bold;
                color: #333;
                margin-bottom: 30px;
              }
              p{
                width: 266px;
                text-align: left;
                font-size: 14px;
                font-weight: 400;
                color: #666;
              }
              img{
                width: 42px;
                position: absolute;
                top: 48px;
                right: 44px;
              }
            }
          }
        }
      }
      .concat{
        width: 100%;
        background:linear-gradient(93deg,rgba(86,103,234,1),rgba(154,166,255,1));
        text-align: center;
        padding: 30px 0 70px;
        .input{
          width: 790px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          input{
            width:250px;
            height:40px;
            background:rgba(247,247,247,1);
            border:1px solid rgba(228,228,228,1);
            border-radius:2px;
            padding: 0 10px;
          }
        }
        .textarea{
          margin-top: 20px;
          textarea{
            width: 790px;
            padding: 10px;
            height:96px;
            background:rgba(247,247,247,1);
            border:1px solid rgba(228,228,228,1);
            border-radius:2px;
          }
        }
        .btn{
          margin-top: 40px;
          border: none;
          button{
            width:170px;
            height:44px;
            background:rgba(255,255,255,1);
            box-shadow:-1px 6px 27px 4px rgba(255,255,255,0.14);
            border-radius:3px;
            font-size:14px;
            font-weight:400;
            color:rgba(86,103,234,1);
            border:none;
          }
        }
      }

      .slideDown {
        animation-name: slideInDown;
      }

      @keyframes slideInDown {
        from {
          transform: translate3d(-50%, -100%, 0);
          visibility: visible;
        }

        to {
          transform: translate3d(-50%, 0, 0);
        }
      }
      .anitr{
        animation: 1s topcity;
        animation-fill-mode: both;
      }
      .anitr-1 {
        animation-delay: .2s
      }

      .anitr-2 {
        animation-delay: .4s
      }

      .anitr-3 {
        animation-delay: .6s
      }

      .anitr-4 {
        animation-delay: .8s
      }

      .anitr-5 {
        animation-delay: 1s
      }

      .anitr-6 {
        animation-delay: 1.2s
      }

      .anitr-7 {
        animation-delay: 1.4s
      }

      @keyframes topcity{
        from {
          opacity: 0.2;
          transform: translate3d(0, 100px, 0);
        }

        to {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
      @keyframes banner{
        0%{ top: 40% }
        100%{ top: 50%; }
      }
    }
    .list-enter-active, .list-leave-active {
      transition: all 1s;
    }
    // 设置初始位置
    .list-enter, .list-leave-to {
      opacity: 0;
      transform: translateX(-30px)
      // transform: translateY(30px);
    }
    .list-move {
      transition: transform 1s;
    }
</style>
